import { DataSource } from "./DataSource";

/**
 * Specifies an object which supports batch updating.
 */
export interface Batchable<TMethods extends object> {

  /**
   * Performs the specified batch update.
   * @param batch The batch update fucntion.
   */
  doBatch(batch: (methods: TMethods) => void): void;
}

/**
 * Indicates whether the specified DataSource implements the Batchable interface.
 * @param dataSource The datasource to test.
 * @returns True if the DataSource implements the Batchable interface, otherwise false.
 */
export function isBatchable(dataSource: DataSource<object>): dataSource is DataSource<object> & Batchable<object> {
  if (!dataSource) return false;
  return Object.prototype.hasOwnProperty.call(dataSource, "doBatch");
}
